import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./welcome.css";
import { Space, Input, Typography, Button, Form } from "antd";
import {
  LockOutlined,
  UserOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { NotificationInfo } from "../../context";

const LoginPage = () => {
  const { rerunNotif } = useContext(NotificationInfo);
  const navigate = useNavigate();
  const [loadings, setLoadings] = useState(false);

  // const handleLogin = (values) => {
  //   const formdata = new FormData();
  //   for (const name in values) {
  //     formdata.append(name, values[name]);
  //   }
  //   setLoadings(true);
  //   axios
  //     .post("auth/login", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data.message === "user-invalid") {
  //         rerunNotif("error", "Invalid credentials.");
  //         setTimeout(() => {
  //           setLoadings(false);
  //         }, 1000);
  //       }
  //       if (data.message === "success") {
  //         rerunNotif("success", "Logged in successfully.");
  //         setTimeout(() => {
  //           setLoadings(false);
  //           localStorage.setItem("digitkn", data.token);
  //           navigate(0);
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoadings(false);
  //     });
  // };

  const handleLogin = (values) => {
    const formdata = new FormData();
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("auth/login", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "user-invalid") {
          rerunNotif("error", "Invalid credentials.");
          setTimeout(() => {
            setLoadings(false);
          }, 1000);
        }
        if (data.message === "success") {
          rerunNotif("success", "Logged in successfully.");
          setTimeout(() => {
            setLoadings(false);
            localStorage.setItem("digitkn", data.token);
            navigate("/");
            navigate(0);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <div className="container2">
      <div className="form-box">
        <div className="form-inner-css">
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={handleLogin}
            autoComplete="off"
          >
            <Space
              direction="vertical"
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1 }} />
                <CloseCircleOutlined
                  style={{ fontSize: 20, color: "#fff", cursor: "pointer" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                />
              </div>

              <Typography.Title
                level={4}
                style={{
                  paddingTop: 5,
                  margin: 0,
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                Login
              </Typography.Title>
              <Form.Item
                style={{ marginBottom: "5px", marginTop: "5px" }}
                name="username"
                rules={[{ required: true, message: "Username is required!" }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Your username"
                  size="large"
                />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: "5px" }}
                name="password"
                rules={[{ required: true, message: "Password is required!" }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Your password"
                  size="large"
                />
              </Form.Item>
              <Typography.Link
                href="/"
                target="_blank"
                style={{ color: "#fff" }}
              >
                Forget Password
              </Typography.Link>
              <Form.Item style={{ marginTop: "5px" }}>
                <Button
                  type="primary"
                  loading={loadings}
                  htmlType="submit"
                  style={{
                    width: "100%",
                    background: "#fff",
                    color: "#000",
                    borderRadius: "20px",
                  }}
                >
                  {loadings ? "Loading" : "Login"}
                </Button>
              </Form.Item>
            </Space>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
